import { AssistantContext } from "@database/contexts";
import { getDocumentations } from "@database/firebase";
import { assistantService } from "@database/services";
import { ChatMessageType, ErrorType } from "@utilities/types";
import { useCallback, useContext, useState } from "react";
import { useOrganisation } from "./useOrganisation";

export const useAssistant = () => {
    
    const { 
        messages, setMessages,
    } = useContext(AssistantContext);
    const { organisation } = useOrganisation();

    const [getInitChatError, setGetInitChatError] = useState<ErrorType | null>(null);
    const [getInitChatLoading, setGetInitChatLoading] = useState<boolean>(false);
    const [sendMessageError, setSendMessageError] = useState<ErrorType | null>(null);
    const [sendMessageLoading, setSendMessageLoading] = useState<boolean>(false);

    const onInitChat = useCallback(async ()=> {
        setGetInitChatLoading(true);
        const { code, data } = await getDocumentations();
        if(code === 200){
            const req = await assistantService.initChat(data.instructions, data.docs);
            if(req.code === 200){
                setMessages(req.data);
            } else {
                setGetInitChatError({
                    message: req.code === 400 ? 
                        "Impossible d'initialiser le chat" :
                        "Une erreur est survenue lors de l'initialisation du chat",
                })
            }
        }
        setGetInitChatLoading(false);
    }, [setMessages]);

    const onSendMessage = useCallback(async (messagesTmp: ChatMessageType[]) => {
        if(!organisation) return;

        setSendMessageLoading(true);
        const req = await assistantService.sendMessage(messagesTmp, organisation._id);
        if(req.code === 200){
            setMessages(req.data);
        } else {
            setSendMessageError({
                message: req.code === 400 ? 
                    "Impossible d'envoyer le message" :
                    req.code === 403 ?
                    "Vous n'êtes pas autorisé à envoyer des messages, votre quota de messages est épuisé, verifiez votre abonnement" :
                    "Une erreur est survenue lors de l'envoi du message",
            })
        }
        setSendMessageLoading(false);
    }, [organisation, setMessages]);

    return {
        messages, setMessages,
        getInitChatError, getInitChatLoading,
        sendMessageError, sendMessageLoading,
        onInitChat, onSendMessage,
    }
};
